import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import { selectReturns } from "../state/reducers/returnsListSlice";
import { Popover } from "react-tiny-popover";
import DatePicker from "react-datepicker";
import cogoToast from "cogo-toast";
import moment from "moment";
import returnService from "../services/return-service";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { selectUsers } from "../state/reducers/userSlice";
import ReactTooltip from "react-tooltip";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import "react-datepicker/dist/react-datepicker.css";

const tablePropsInit = {
  columns: [
    { key: "rxCode", title: "RX" },
    { key: "returnedDate", title: "Return Date" },
    { key: "returnedQuantity", title: "Qty Returned" },
    { key: "drugName", title: "Drug" },
    { key: "inmateName", title: "Inmate Name" },
    { key: "inmateAcct", title: "Inmate" },
    { key: "facilityName", title: "Facility" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "returnId",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const ReturnsList = ({ history }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { itemsList } = useSelector(selectReturns);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [loading, setLoading] = useState(false);
  let { user } = useSelector(selectUsers);
  const { loggedTime } = useSelector(selectUsers);
  const filterReturns = async () => {
    if (!startDate || !endDate || startDate > endDate) {
      const { hide } = cogoToast.error(
        "Please chose valid start date and end date ",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
    } else {
      try {
        let date1 = moment(startDate).format("YYYY-MM-DD");
        let date2 = moment(endDate).format("YYYY-MM-DD");
        let returnList = [];
        setLoading(true);
        setIsPopoverOpen(false);
        returnList = await returnService.getReturns(date1, date2);
        setLoading(false);
        if (returnList?.length === 0) {
          const { hide } = cogoToast.error("No Records Found!", {
            hideAfter: 15,
            onClick: () => {
              hide();
            },
          });
        } else {
          dispatch1(updateData(returnList));
        }
      } catch (e) {
        console.error(e);
      }
    }
  };
  const downloadReport = async () => {
    let reportStartDate = loggedTime;
    let reportEndDate = new Date().toLocaleDateString("en-US");
    let date_txt = "";
    if (startDate && endDate) {
      reportStartDate = moment(startDate).format("MM-DD-YYYY");
      reportEndDate = moment(endDate).format("MM-DD-YYYY");
      date_txt = reportStartDate + " to " + reportEndDate;
    } else {
      reportStartDate = moment(loggedTime).format("MM-DD-YYYY");
      reportEndDate = moment(endDate).format("MM-DD-YYYY");
      date_txt = reportStartDate + " to " + reportEndDate;
    }
    const doc = new jsPDF("", "", "a3");
    doc.setFont("helvetica");
    doc.setFontSize(9);
    doc.text("Clinical Solutions Pharmacy Services", 140, 20, "center");
    doc.text(
      "Return Report for " + user?.facilityName + " for " + date_txt + "",
      140,
      30,
      "center"
    );
    doc.text(
      "**Please print 2 copies. One for your Records and one to send back to Pharmacy**",
      140,
      36,
      "center"
    );
    doc.text(
      "Return Prepared By: _________________________________________________ Requested Items Destroyed By: __________________________________________",
      140,
      45,
      "center"
    );
    setLoading(true);
    let returnList = await returnService.getReturns(
      reportStartDate,
      reportEndDate
    );
    setLoading(false);
    let col = [
      "RX",
      "Return Date",
      "Qty Returned",
      "Drug",
      "Inmate Name",
      "Inmate",
      "Facility",
    ];
    let rows = [];
    doc.setFontSize(12);
    doc.setFont("helvetica");
    doc.setFontSize(8);
    let top = 345;
    returnList.forEach((ele, i) => {
      let temp = [
        ele.rxCode,
        moment.utc(ele.returnedDate).format("MM-DD-YYYY"),
        ele.returnedQuantity,
        ele?.drugName +
          " " +
          (ele?.strength ? ele?.strength : "") +
          " " +
          (ele?.dosage ? ele?.dosage : ""),
        ele.inmateName,
        ele?.inmateAcct === "-" ? "" : ele?.inmateAcct,
        ele.facilityName,
      ];
      top = top + 5;
      rows.push(temp);
    });
    doc.autoTable(col, rows, { startY: 55 }, "left");
    doc.save("report.pdf");
  };
  useEffect(() => {}, [user]);
  let dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      dispatch1(updateData(itemsList));
    }
  };
  const CustomCell = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block mr-3">
          {moment.utc(rowData?.returnedDate).format("MM-DD-YYYY") || ""}
        </span>
      </div>
    );
  };
  const CustomCell1 = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block mr-3">
          {rowData?.drugName + " " || ""}
          {rowData?.strength + " " || ""}
          {rowData?.dosage || ""}
        </span>
      </div>
    );
  };
  const CustomCell2 = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block mr-3">{rowData?.inmateName || ""}</span>
      </div>
    );
  };
  const CustomCell3 = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block mr-3">
          {rowData?.inmateAcct === "-" ? "" : rowData?.inmateAcct}
        </span>
      </div>
    );
  };
  const CustomCell4 = ({ rowData }) => {
    return (
      <div>
        <span className="inline-block mr-3">
          {rowData?.inmatePossession ? "YES" : "NO"}
        </span>
      </div>
    );
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <ReactTooltip />
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
          <span className="text-xl">RETURNS</span>
          </div>
          {user.userRole === "PORTAL_ADMIN" ? null : (
            <div className="w-full sm:w-1/2 text-right">
              <span className="mr-3">
              <Popover
                isOpen={isPopoverOpen}
                positions={["bottom"]} // preferred positions by priority
                content={
                  <div className="bg-bodybgrnd rounded border-2 sm:flex p-2">
                    <div className="relative mb-3 sm:md-0">
                      <p className="text-menu_txt text-xs font-semibold mb-1">
                        Start Date
                      </p>
                      <DatePicker
                        placeholderText="MM/DD/YYYY"
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                        }}
                        className="shadow-loginshadow h-8 rounded pl-2 text-labelclr font-semibold text-xs w-full mb-3 border"
                      />
                    </div>
                    <div className="sm:ml-2 relative">
                      <p className="text-menu_txt text-xs font-semibold mb-1">
                        End Date
                      </p>
                      <DatePicker
                        placeholderText="MM/DD/YYYY"
                        selected={endDate}
                        onChange={(date) => {
                          setEndDate(date);
                        }}
                        className="shadow-loginshadow h-8 rounded pl-2 text-labelclr font-semibold text-xs tracking-wider pl-2"
                      />
                    </div>
                    <button
                      onClick={() => {
                        filterReturns();
                      }}
                      type="button"
                      className="text-white w-full sm:w-auto h-8 px-6 mt-2 sm:mt-5 sm:ml-2 bg-header_bg rounded text-xs font-semibold capitalize"
                    >
                      SUBMIT
                    </button>
                  </div>
                }
              >
                <div className="bg-bodybgrnd rounded border-2 border-searchclr mb-2 inline-flex shadow-loginshadow p-2 cursor-pointer">
                  <svg
                    onClick={() => {
                      setIsPopoverOpen(!isPopoverOpen);
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-funnel"
                    viewBox="0 0 16 16"
                  >
                    <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z" />
                  </svg>
                </div>
              </Popover>
              </span>
              <span className="mr-3">
                <button
                  onClick={() => {
                    downloadReport();
                  }}
                  className="bg-header_bg rounded py-2 px-7 cursor-pointer mb-2 text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
                >
                  DOWNLOAD REPORT
                </button>
              </span>
              <span className="mr-3">
                <Link
                  to="/barcode-search"
                  className="bg-header_bg rounded py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
                >
                  NEW
                </Link>
              </span>
            </div>
          )}
        </div>
        <div className="py-2 text-xs gridList px-2 overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "returnedDate":
                      return <CustomCell {...props} />;
                    case "drugName":
                      return <CustomCell1 {...props} />;
                    case "inmateName":
                      return <CustomCell2 {...props} />;
                    case "inmateAcct":
                      return <CustomCell3 {...props} />;
                    case "inmatePossession":
                      return <CustomCell4 {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch1}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(ReturnsList)
);
